import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { getFieldType } from './get-field-type.js'
export function getInputFieldType(field: SchemaField): string {
  const fieldType = getFieldType(field, 'input')
  if (!field.required && (field.type === 'number' || field.type === 'decimal')) {
    return `${fieldType} | null`
  }
  return fieldType
}
